import $ from "jquery";
import "jquery.scrollto";

document.body.addEventListener("custom:formsubmit", function(ev) {
    const formname = ev.detail;
    if(formname == "contactform") {
      const $linner = $(".bl-mmxform.form-1").find(".linner");
      $linner.children().hide();
      $linner.find(".wl-contactform-thanksmsg").show();

      //const headerHeight = $("header").outerHeight();

      //window.scrollTo({ top: 0, behavior: "smooth" });
      $(window).scrollTo($(".bl-mmxform.form-1"), 1000, {
          //offset: -headerHeight
      });
    }
});

/*
const contactform = document.getElementsByClassName("form-contactform");
  if(contactform.length > 0) {
    contactform[0].scrollIntoView({behavior: "smooth"});
  }
*/